import { PARKING_TYPES, PARKING_TYPE_LABELS, labelledOptions } from '@resida/shared';
import { ProfileSection } from './ProfileSection';
import { inputClass, labelClass } from './fieldClasses';
import { PARKING_TYPES_WITH_EXTRAS, type MarketingDraft } from './marketingDraft';

const PARKING_TYPE_OPTIONS = labelledOptions(PARKING_TYPES, PARKING_TYPE_LABELS);

interface Props {
  draft: MarketingDraft;
  onChange: (patch: Partial<MarketingDraft>) => void;
}

export function ProfileSectionParking({ draft, onChange }: Props) {
  const showExtras = PARKING_TYPES_WITH_EXTRAS.has(draft.parkingType);
  return (
    <ProfileSection title="Parking" testId="marketing-details-parking">
      <div className="flex flex-col gap-4">
        <div className="sm:w-1/2">
          <label htmlFor="parking-type" className={labelClass}>Parking type</label>
          <select
            id="parking-type"
            value={draft.parkingType}
            onChange={(e) => onChange({ parkingType: e.target.value })}
            data-testid="profile-parking-type-select"
            className={inputClass}
          >
            <option value="">— Select —</option>
            {PARKING_TYPE_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))}
          </select>
        </div>
        {showExtras && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <label htmlFor="parking-spaces" className={labelClass}>Number of spaces</label>
              <input
                id="parking-spaces"
                type="number"
                value={draft.parkingSpaces}
                onChange={(e) => onChange({ parkingSpaces: e.target.value })}
                min={1}
                max={20}
                placeholder="e.g. 2"
                data-testid="profile-parking-spaces-input"
                className={inputClass}
              />
            </div>
            <label htmlFor="parkingIncluded" className="flex min-h-[44px] cursor-pointer items-center gap-2 text-sm text-foreground sm:pt-5">
              <input
                type="checkbox"
                id="parkingIncluded"
                checked={draft.parkingIncluded}
                onChange={(e) => onChange({ parkingIncluded: e.target.checked })}
                data-testid="profile-parking-included-checkbox"
                className="h-4 w-4 rounded border-input text-primary"
              />
              Included in rent
            </label>
          </div>
        )}
      </div>
    </ProfileSection>
  );
}
